module.exports = __webpack_public_path__ + "assets/images/popups/at_symbol.png";